import {appConsts} from 'src/constants/appConsts';
import {apolloClient, restartSocket} from 'src/apollo';

/**
 * Хранение токена сессии. Как в otveto (utils/auth.tsx), но без sessionStorage
 * и кросс-доменного SSO — у складской сети один домен и один кабинет.
 */
export const getToken = (): string | null => localStorage.getItem(appConsts.AUTH_TOKEN);

/**
 * Запоминает токен пользователя, чистит кэш Apollo.
 *
 * Кэш чистим и на входе, а не только на выходе: до входа в кэше могли остаться
 * ответы прежнего пользователя (сессию отозвали, страницу не перезагружали), и
 * тогда новый видел бы в кабинете чужие данные до первого рефетча.
 */
export const setToken = async (token: string): Promise<void> => {
	localStorage.setItem(appConsts.AUTH_TOKEN, token);
	localStorage.removeItem(appConsts.AUTH_KIND);

	try {
		await apolloClient.clearStore();
	} catch {
		// Сбой очистки кэша не должен отменять установленную сессию.
	}

	// Переподключить WS с новым токеном: сокет, открытый до входа, иначе остался бы
	// с прежним connectionParams (SKS-249)
	restartSocket();
};

/**
 * Забывает токен и чистит кэш Apollo. Кэш обязателен: без него данные
 * прошлого пользователя останутся в памяти и покажутся следующему.
 */
export const clearToken = async (): Promise<void> => {
	localStorage.removeItem(appConsts.AUTH_TOKEN);
	localStorage.removeItem(appConsts.AUTH_KIND);

	try {
		await apolloClient.clearStore();
	} catch {
		// Сбой очистки кэша не должен мешать выходу и закрытию сокета.
	}

	// Закрыть WS: по нему live-подписки (в т.ч. full-payload лента чата) не должны
	// продолжать течь после выхода — реконнект пройдёт onConnect уже без токена (SKS-249)
	restartSocket();
};

/** Убираем прежний веб-вход до загрузки экранов, не отзывая сессию на сервере. */
export const clearLegacyMemberSession = async (): Promise<boolean> => {
	if (localStorage.getItem(appConsts.AUTH_KIND) !== 'member') return false;

	await clearToken();
	try {
		// Сохранённый разговор сотрудника не должен открыться у следующего пользователя.
		sessionStorage.removeItem('wn.active-call');
	} catch {
		// В приватном режиме sessionStorage может быть недоступен.
	}
	return true;
};
